// 未登録ユーザー
$(() => {
    if (document.getElementById('unregistered_users') != null) {
        $('.search').on('change', function(e) {
            $('#form').submit();
        });
    }
});
